<div class="family-room-container" [ngStyle]="{display: isEditing ? 'none' : 'block'}">
  <div class="header">Family Room Directory</div>
  <div class="sub-header">Discover Who's Who in the Family Room.</div>
  <div class="search-header">Who are you looking for?</div>
  <div class="search-input-container">
    <input type="text" id="search-input" placeholder="Type in a name or affiliation (e.g. Lawson)"
           [(ngModel)]="filterString">
  </div>
  <div class="search-filters">
    <div class="filter" (click)="updateActiveFilter(familyFriendOption)"
         [ngClass]="{'active': activeFilter === familyFriendOption}">Family & Friends
    </div>
    <div class="filter" (click)="updateActiveFilter(staffOption)" [ngClass]="{'active': activeFilter === staffOption}">
      Thunder Staff
    </div>
  </div>
  <mat-checkbox class="exclude-hidden-people" *ngIf="perms['Operator']" [(ngModel)]="excludeHiddenPeople">Exclude hidden people</mat-checkbox>

  <div class="person-grid">
    <ng-container *ngFor="let person of filteredPeople; index as i;">
      <div class="person-block" *ngIf="(perms['Operator'] && !excludeHiddenPeople) || person.showInFamilyRoom || !person.isFamilyFriend" [ngStyle]="{opacity: person.showInFamilyRoom || !person.isFamilyFriend ? 1 : 0.4}">
        <div class="person-block-inner">
          <div class="person-thumbnail" [ngStyle]="{    'background-image': person?.imageUrl ? 'url(' + person.imageUrl + ')' : 'url(assets/placeholder.png)'}">
            <mat-icon class="edit-icon" (click)="startEditing(person)" *ngIf="person.isFamilyFriend && !isMobile && perms['Operator']">edit</mat-icon>
          </div>
          <h5 class="person-name">{{ person.name }}</h5>
          <p *ngIf="person.description" class="person-subtext">{{ person.description }}</p>
          <p *ngIf="person.affiliationName"
             class="person-subtext">{{ person.relationshipName }}{{ person.relationshipName ? ', ' : '' }} {{ person.affiliationName }}</p>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="add-button" (click)="addEntity()" *ngIf="!isMobile && perms['Operator']">
    <mat-icon class="download-icon">add</mat-icon>
  </div>

</div>
<div class="family-room-container editing" *ngIf="isEditing">
  <div class="image-container">
    <family-room-directory-upload [person]="personEditing"></family-room-directory-upload>
  </div>
  <div class="edit-panel" *ngIf="isEditing">
    <div class="search-filters edit">
      <div class="header" (click)="isGeneralExpanded = !isGeneralExpanded">
        <mat-icon [ngStyle]="{transform: isGeneralExpanded ? 'rotate(90deg)' : 'rotate(0deg)'}">keyboard_arrow_right
        </mat-icon>
        <span [ngClass]="{invalid: !isNameValid}">General<span *ngIf="!isNameValid">*</span></span>
      </div>
      <div class="inside general" [ngStyle]="{height: isGeneralExpanded ? 'unset' : 0}">
        <mat-form-field class="name-form-field">
          <input matInput class="description" [placeholder]="'First Name'" [(ngModel)]="personEditing.firstNameDisplay">
        </mat-form-field>
        <mat-form-field class="name-form-field last">
          <input matInput class="description" [placeholder]="'Last Name'" [(ngModel)]="personEditing.lastNameDisplay">
        </mat-form-field>
        <mat-checkbox [(ngModel)]="personEditing.showInFamilyRoom">Show in Family Room Directory</mat-checkbox>
      </div>
      <div class="header" (click)="isEntitiesExpanded = !isEntitiesExpanded">
        <mat-icon [ngStyle]="{transform: isEntitiesExpanded ? 'rotate(90deg)' : 'rotate(0deg)'}">keyboard_arrow_right
        </mat-icon>
        <span [ngClass]="{invalid: !isAffiliationValid}">Affiliation<span *ngIf="!isAffiliationValid">*</span></span>
      </div>
      <div class="inside" [ngStyle]="{height: isEntitiesExpanded ? 'unset' : 0}">
        <mat-form-field class="affiliation-form-field">
          <mat-chip-grid #peopleChipList>
            <mat-chip-row *ngIf="personEditing?.affiliationName">
              {{ personEditing.affiliationName }}
              <mat-icon matChipRemove (click)="removeAffiliation()">cancel</mat-icon>
            </mat-chip-row>
            <input #peopleInput matInput class="tag-input" placeholder="Add an entity" [ngStyle]="{display: personEditing?.affiliationName ? 'none' : 'block'}"
                   [matAutocomplete]="peopleAutocomplete" [matChipInputFor]="peopleChipList" [formControl]="affiliationControl">
          </mat-chip-grid>
          <mat-autocomplete autoActiveFirstOption #peopleAutocomplete="matAutocomplete" (optionSelected)="addAffiliation($event)">
            <mat-option *ngFor="let person of filteredAffiliations" [value]="person">
              {{ person.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="header" (click)="isRelationshipCategoryExpanded = !isRelationshipCategoryExpanded">
        <mat-icon [ngStyle]="{transform: isRelationshipCategoryExpanded ? 'rotate(90deg)' : 'rotate(0deg)'}">keyboard_arrow_right
        </mat-icon>
        <span [ngClass]="{invalid: !isRelationshipValid}">Relationship Category<span *ngIf="!isRelationshipValid">*</span></span>
      </div>
      <div class="inside" [ngStyle]="{height: isRelationshipCategoryExpanded ? 'unset' : 0}">
        <mat-radio-group class="edit-radio-group" aria-label="Select an option">
          <mat-radio-button color="primary" value="1" [checked]="personEditing?.relationshipTypeID == 1" (change)="updateRelationshipType($event)">Mother</mat-radio-button>
          <mat-radio-button color="primary" value="2" [checked]="personEditing?.relationshipTypeID == 2" (change)="updateRelationshipType($event)">Father</mat-radio-button>
          <mat-radio-button color="primary" value="3" [checked]="personEditing?.relationshipTypeID == 3" (change)="updateRelationshipType($event)">Sibling</mat-radio-button>
          <mat-radio-button color="primary" value="4" [checked]="personEditing?.relationshipTypeID == 4" (change)="updateRelationshipType($event)">Wife</mat-radio-button>
          <mat-radio-button color="primary" value="5" [checked]="personEditing?.relationshipTypeID == 5" (change)="updateRelationshipType($event)">Partner</mat-radio-button>
          <mat-radio-button color="primary" value="6" [checked]="personEditing?.relationshipTypeID == 6" (change)="updateRelationshipType($event)">Child</mat-radio-button>
          <mat-radio-button color="primary" value="7" [checked]="personEditing?.relationshipTypeID == 7" (change)="updateRelationshipType($event)">Extended Family</mat-radio-button>
          <mat-radio-button color="primary" value="8" [checked]="personEditing?.relationshipTypeID == 8" (change)="updateRelationshipType($event)">Friend</mat-radio-button>
          <mat-radio-button color="primary" value="9" [checked]="personEditing?.relationshipTypeID == 9" (change)="updateRelationshipType($event)">Other</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>
  <div class="cancel-button" *ngIf="isEditing" (click)="stopEditing()">Cancel</div>
  <div class="save-button" *ngIf="isEditing" (click)="saveUpdates()">Save</div>
</div>
